import * as React from 'react'
import { Checkbox, Popover, Button, Position, Classes } from '@blueprintjs/core'
import CX from 'classnames'
import { niceNumber } from '../../utils/number'

interface Value {
  allSelected: boolean
  allChecked: boolean
}

export interface Props {
  actionChildren: JSX.Element
  value: Value
  loading: boolean
  selectedCount: number
  inViewCount: number
  totalCount: number
  totalStatus?: string
  onChange: (newValue: Value) => void
}

const SelectAllButton: React.FC<Props> = ({
  actionChildren,
  value,
  loading,
  selectedCount,
  onChange,
  inViewCount,
  totalCount,
  totalStatus
}) => {
  const { allChecked, allSelected } = value
  const everythingChecked = selectedCount === inViewCount || allChecked

  const moreThan = totalStatus && totalStatus === 'MORE_THAN' ? ` more than${niceNumber(totalCount)}` : null

  let selectAllMessage = null
  if (allSelected) {
    if (moreThan) {
      selectAllMessage = `All items selected (more than ${niceNumber(totalCount)})`
    } else {
      selectAllMessage = `All ${niceNumber(totalCount)} are selected`
    }
  } else {
    // eslint-disable-next-line no-lonely-if
    if (moreThan) {
      selectAllMessage = `Select all items (more than ${niceNumber(totalCount)})`
    } else {
      selectAllMessage = `Select all ${niceNumber(totalCount)}`
    }
  }

  return (
    <>
      <div className="bp5-button select-button">
        <Checkbox
          indeterminate={selectedCount !== inViewCount}
          checked={everythingChecked}
          onChange={() => {
            if (everythingChecked) {
              onChange({ allChecked: false, allSelected: false })
              return
            }

            if (selectedCount !== inViewCount) {
              onChange({ allChecked: true, allSelected })
            }
          }}
        />
        {selectedCount}
        {allSelected ? '+' : ''} selected
      </div>
      <Popover position={Position.BOTTOM} content={actionChildren}>
        <Button
          disabled={loading}
          style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
          text="Actions"
          rightIcon="caret-down"
        />
      </Popover>
      {selectedCount < totalCount && (
        <>
          <a
            className={CX('select-more-orders', { [Classes.DISABLED]: loading })}
            onClick={() => onChange({ allChecked: true, allSelected: true })}
            style={{
              color: allSelected && 'black',
              cursor: allSelected && 'default'
            }}
          >
            {selectAllMessage}
          </a>
          {allSelected && (
            <a
              style={{ marginLeft: 5 }}
              onClick={() => onChange({ allChecked: everythingChecked, allSelected: false })}
            >
              Undo
            </a>
          )}
        </>
      )}
    </>
  )
}

export default SelectAllButton
